import Backbone from 'backbone';
import DateParser from 'utils/date/DateParser';
import moment from 'moment';
import TrainingPlanUtil, { TrainingVersion } from 'pages/training_plans/utils/TrainingPlanUtil';

var Status = {
        Active: 'Active',
        Scheduled: 'Scheduled',
        Completed: 'Completed'
    },
    Levels = {
        Beginner: 'training_plans_filter_level_1',
        Intermediate: 'training_plans_filter_level_2',
        Advanced: 'training_plans_filter_level_3'
    },
    LevelColors = {
        training_plans_filter_level_1: 'lt-grey',
        training_plans_filter_level_2: 'lt-grey',
        training_plans_filter_level_3: 'lt-grey'
    },
    ActivityTypes = {
        Running: 'Running',
        Cycling: 'Cycling',
        Triathlon: 'Triathlon'
    },
    Distances = {
        '5k': '5k',
        '10k': '10k',
        HalfMarathon: 'HalfMarathon',
        Marathon: 'Marathon',
        Other: 'Other',
        Century: 'Century',
        Sprint: 'Sprint',
        Olympic: 'Olympic'
    };

var plan = Backbone.Model.extend({
    idAttribute: 'trainingPlanId',

    initialize: function() {
        this.trainingPlanUtil = new TrainingPlanUtil();
    },

    url: function() {
        return '/trainingplan-service/trainingplan/' + this.id;
    },
    backend: 'gcapi',

    parse: function(response) {
        if (response) {
            var todayDate = new Date();
            todayDate.setHours(0, 0, 0, 0);
            this.setTrainingPlanStatus(response, todayDate);
            this.setTrainingPlanLevel(response);
        }

        return response;
    },

    save: function(attributes, opts) {
        var options = opts || {};

        options.url = '/trainingplan-service/trainingplan/schedule/' + this.id;
        options.backend = 'gcapi';
        options.contentType = 'application/json';
        options.type = 'GET';
        options.data = 'startDate=' + this.get('startDate');

        return Backbone.Model.prototype.save.call(this, attributes, options);
    },

    destroy: function(opts) {
        var options = opts || {};

        options.dataType = 'text';
        options.url = '/trainingplan-service/trainingplan/trainingplan/' + this.id;
        options.backend = 'gcapi';
        options.contentType = 'application/json';
        options.type = 'DELETE';

        return Backbone.Model.prototype.destroy.call(this, options);
    },

    getTrainingPlanStatus: function(trainingPlan, todayDate) {
        var status = trainingPlan.trainingStatus.statusKey;

        if (trainingPlan && todayDate) {
            var endDate = moment(DateParser.parseISO(trainingPlan.endDate)),
                startDate = moment(DateParser.parseISO(trainingPlan.startDate));

            todayDate = moment(todayDate);

            if (endDate.isBefore(todayDate)) {
                status = Status.Completed;
            } else if (startDate.isSameOrBefore(todayDate) && endDate.isSameOrAfter(todayDate)) {
                status = Status.Active;
            } else {
                status = Status.Scheduled;
            }
        }

        return status;
    },

    setTrainingPlanStatus: function(trainingPlan, todayDate) {
        //when time permits, API should change this to return us the actual plan status
        //so all the platforms consuming this endpoint doesn't have to do this
        trainingPlan.trainingStatus.statusKey = this.getTrainingPlanStatus(trainingPlan, todayDate);
    },

    setTrainingPlanLevel: function(trainingPlan) {
        //when time permits, API should change this to return us the actual plan status
        //so we do have to map the values to the display values
        if (trainingPlan && typeof trainingPlan.trainingLevel.levelKey !== 'object') {
            trainingPlan.trainingLevel.levelKey = [trainingPlan.trainingLevel.levelKey];
        }
    },

    isHeartRateBased: function() {
        return this.get('trainingVersion').versionName === TrainingVersion.HeartRate;
    },

    isPowerBased: function() {
        return this.get('trainingVersion').versionName === TrainingVersion.Power;
    },

    getActivityIconClass: function() {
        var type = this.get('trainingType').typeKey.toLowerCase();
        const isUnbound = this.trainingPlanUtil.isConsideredUnbound(this.get('planKey'));

        if (isUnbound) {
            return 'icon-cycling-gravel';
        }

        if (type === 'triathlon') {
            type = 'multisport';
        }

        if (type === 'strength') {
            type = 'strength-training';
        }

        return 'icon-activity-' + type;
    },

    isAdaptive: function() {
        return false;
    }
});

plan.Status = Status;
plan.Levels = Levels;
plan.ActivityTypes = ActivityTypes;
plan.Distances = Distances;

export default plan;
